import React, { memo } from "react";
import cx from "classnames";
import { NumberInput } from "components/Inputs/NumberInput";
import * as identify from "utils/treeUtils";
import { IconButton } from "components/IconButton/IconButton";
import { EditNodeTypes } from "../EditNodeTypes";
import s from "../Styles.module.scss";

export const ConfigurationControls = memo(
  ({
    configId,
    isPasteMode,
    handleToggleEditMode,
    isEditMode,
    handleCopyNode,
    handleDelete,
    handleUpdateQuantity,
    openDownloadModal,
    options,
    isNodeOptimistic,
    translations,
    data,
    handleToggle3dView,
    onClickOutside,
    canDeleteInAddToProjectModal = false,
  }) => (
    <div className="d-flex flex-row align-items-center justify-content-between w-100">
      <Quantity
        isEditMode={isEditMode === EditNodeTypes.QUANTITY}
        handleToggleEditMode={() =>
          !identify.isTroxNetcom(data) &&
          !identify.isProductAccessory(data) &&
          handleToggleEditMode(EditNodeTypes.QUANTITY)
        }
        quantity={data.quantity}
        translations={translations}
        onClickOutside={onClickOutside}
        handleUpdate={handleUpdateQuantity}
        options={options}
      />
      <div
        className={cx(
          "d-flex ms-2 flex-row align-items-center justify-content-end flex-shrink-0",
          s.borderBetween,
        )}
      >
        {!options.editNodeDisabled &&
          !identify.isWizard(data) &&
          !identify.isTroxNetcom(data) && (
            <IconButton
              testId="editConfigButton"
              id={`editConfig${configId}`}
              icon="pencil-light"
              iconClassName="icon-16"
              onClick={() => handleToggleEditMode(EditNodeTypes.TITLE)}
              className={cx("px-2 border-0", {
                "cursor-not-allowed opacity-20 pe-none": isPasteMode,
              })}
              tooltipText={translations.folder.editNode}
              disabled={isPasteMode}
            />
          )}
        {!options.copyNodeDisabled && !identify.isProductAccessory(data) && (
          <IconButton
            id={`copyConfig${data.id}`}
            tooltipText={translations.folder.copyNode}
            testId="copyIcon"
            icon="copy-light"
            iconClassName="icon-16"
            onClick={handleCopyNode}
            className={cx("px-2 border-0", {
              "cursor-not-allowed opacity-20 pe-none": isPasteMode,
            })}
            disabled={isPasteMode}
          />
        )}
        {!options.ModelViewDisabled &&
          !identify.isTroxNetcom(data) &&
          !identify.isCustomProduct(data) && (
            <IconButton
              id={`modelView${data.id}`}
              tooltipText={translations.product.modelView}
              testId="3dViewIcon"
              iconPrefix="trox"
              icon="3-d-symbol-regular"
              iconClassName="icon-16"
              onClick={handleToggle3dView}
              className={cx("px-2 border-0", {
                "cursor-not-allowed opacity-20 pe-none": isPasteMode,
              })}
              disabled={isPasteMode}
            />
          )}
        {!options.downloadModalDisabled &&
          !identify.isWizard(data) &&
          !identify.isTroxNetcom(data) &&
          !identify.isCustomProduct(data) && (
            <IconButton
              id={`downloadModal${data.id}`}
              tooltipText={translations.product.download}
              testId="downloadIcon"
              iconPrefix="trox"
              icon="arrow-down-bracket-light"
              iconClassName="icon-16"
              onClick={openDownloadModal}
              className={cx("px-2 border-0", {
                "cursor-not-allowed opacity-20 pe-none": isPasteMode,
              })}
              disabled={isPasteMode}
            />
          )}
        {!identify.isWizard(data) &&
          !identify.isTroxNetcom(data) &&
          !identify.isProductAccessory(data) &&
          ((!options.productAddingModal && !options.deleteNodeDisabled) ||
            (options.productAddingModal && canDeleteInAddToProjectModal)) && (
            <IconButton
              id={`deleteConfig${data.id}`}
              tooltipText={translations.folder.deleteNode}
              testId="deleteIcon"
              icon="trash-can-light"
              iconClassName="icon-16"
              onClick={handleDelete}
              className={cx("px-2 border-0", {
                "cursor-not-allowed opacity-20 pe-none":
                  (isPasteMode && !options.productAddingModal) ||
                  isNodeOptimistic,
              })}
              disabled={
                (isPasteMode && !options.productAddingModal) || isNodeOptimistic
              }
            />
          )}
      </div>
    </div>
  ),
);

const Quantity = ({
  options,
  isEditMode,
  quantity,
  handleUpdate,
  translations,
  handleToggleEditMode,
  onClickOutside,
}) => {
  if (options.hideProductQuantity) {
    return <></>;
  }
  if (options.simpleQuantityView) {
    return <>{quantity}</>;
  }
  return (
    <div
      className="d-flex align-items-center gap-1 py-2"
      onClick={() => !isEditMode && handleToggleEditMode()}
    >
      <span>{translations.product.productQuantity}:</span>
      <div data-testid="product-quantity-input">
        {isEditMode ? (
          <NumberInput
            initialValue={quantity}
            onSave={handleUpdate}
            onClickOutside={onClickOutside}
            min={1}
            max={9999}
          />
        ) : (
          quantity
        )}
      </div>
    </div>
  );
};
